"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const uuid = __importStar(require("uuid"));
const Api = __importStar(require("@src/api"));
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const elements_1 = require("@src/components/elements");
const UploadFields_1 = require("@src/components/pages/admin/modules/company-info-edit/form-fields/UploadFields");
const companyInfoEditFormRules_1 = require("@src/components/pages/admin/modules/company-info-edit/companyInfoEditFormRules");
const AddressFields_1 = require("@src/components/modules/global/AddressFields");
function getImageThumb(pictureUrl) {
    return (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: `web/company/${pictureUrl}`,
        transformation: 'w_140,h_140,c_limit',
    });
}
const CompanyProfileHeaderEditForm = react_1.default.forwardRef(({ setIsEditModalOpen, company }, ref) => {
    const intl = (0, react_intl_1.useIntl)();
    const [form] = antd_1.Form.useForm();
    const { invalidateSSRContext } = (0, useSSRFetch_1.useSSRFetchClient)();
    // @ts-ignore
    const rules = (0, companyInfoEditFormRules_1.companyInfoEditFormRules)(intl, company);
    const { mutateAsync: updateCompanyProfileInfo } = (0, useAppMutation_1.useAppMutation)(Api.CompanyPremiumProfile.setCompanyPremiumProfileHeaderInfo, {
        onSuccess: () => {
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'general.warning',
                }),
                description: intl.formatMessage({
                    id: 'general.successfuly_saved',
                }),
            });
            invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.companyProfile.key);
        },
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        },
    });
    const [imageFile, setImageFile] = react_1.default.useState([]);
    const [titleFile, setTitleFile] = react_1.default.useState([]);
    const initialValues = react_1.default.useMemo(() => ({
        [types_1.CompanyInfoEditFormField.image]: company.image,
        [types_1.CompanyInfoEditFormField.title_image]: company.titleImageUrl,
        [types_1.CompanyInfoEditFormField.address]: company.address,
        [types_1.CompanyInfoEditFormField.website]: company.website,
    }), [company]);
    const initImages = () => {
        const { image } = company;
        const titleImage = company.titleImageUrl;
        if (image) {
            const imageThumb = getImageThumb(image);
            setImageFile([{ thumbUrl: imageThumb, uid: uuid.v4() }]);
        }
        if (titleImage) {
            const titleImageThumb = getImageThumb(titleImage);
            setTitleFile([{ thumbUrl: titleImageThumb, uid: uuid.v4() }]);
        }
    };
    react_1.default.useEffect(() => {
        initImages();
    }, [company.image, company.titleImageUrl]);
    const validateFormFields = async () => {
        await form.validateFields();
        return true;
    };
    const submitForm = async () => {
        var _a, _b;
        const validationPassed = await validateFormFields();
        if (!validationPassed) {
            return;
        }
        const formValues = form.getFieldsValue();
        const shouldDeleteTitleImage = Boolean(initialValues.title_image && titleFile.length === 0);
        const shouldDeleteCompanyImage = Boolean(initialValues.image && imageFile.length === 0);
        const shouldSetCompanyImage = Boolean(imageFile.length === 1);
        const shouldSetTitleImage = Boolean(titleFile.length === 1);
        await updateCompanyProfileInfo({
            companyPremiumProfileInfo: formValues,
            shouldDeleteTitleImage,
            shouldDeleteCompanyImage,
            shouldSetCompanyImage,
            shouldSetTitleImage,
            companyImage: (_a = imageFile[0]) === null || _a === void 0 ? void 0 : _a.originFileObj,
            companyTitleImage: (_b = titleFile[0]) === null || _b === void 0 ? void 0 : _b.originFileObj,
        });
        setIsEditModalOpen(false);
    };
    react_1.default.useImperativeHandle(ref, () => ({ submitForm }));
    if (!company) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(antd_1.Form, { form: form, layout: "vertical", scrollToFirstError: true, initialValues: initialValues, children: [(0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 16], children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                                id: 'company.image',
                            }), name: types_1.CompanyInfoEditFormField.image, children: (0, jsx_runtime_1.jsx)(elements_1.ImageUpload, { name: "image", accept: "image/*", aspect: 1, cropSize: { width: 600, height: 600 }, beforeUpload: e => (0, UploadFields_1.checkImageSize)(e, 1, intl), wholeFileList: imageFile, setFileList: setImageFile, modalTitle: `${intl.formatMessage({
                                    id: 'admin.company_premium_profile.upload_modal_title',
                                })} (1:1, max. 1MB)` }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                                id: 'company.title_image',
                            }), name: types_1.CompanyInfoEditFormField.title_image, children: (0, jsx_runtime_1.jsx)(elements_1.ImageUpload, { name: "title_image_url", accept: "image/*", aspect: 5 / 1, beforeUpload: e => (0, UploadFields_1.checkImageSize)(e, 2, intl), wholeFileList: titleFile, setFileList: setTitleFile, modalTitle: `${intl.formatMessage({
                                    id: 'admin.company_premium_profile.upload_modal_title',
                                })} (5:1, max. 2MB)` }) }) })] }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 12, children: (0, jsx_runtime_1.jsx)(AddressFields_1.AddressFields, { baseName: "address", form: form, countryLabel: intl.formatMessage({ id: 'general.country' }), formattedAddressLabel: intl.formatMessage({ id: 'company.address' }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, md: 12, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                        id: 'admin.company_premium_profile.company_web_page',
                    }), name: types_1.CompanyInfoEditFormField.website, rules: rules.websiteRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }) })] }));
});
exports.default = CompanyProfileHeaderEditForm;
